{
  "familyId": "SWW-VD-ZONDER-GE",
  "questions": [
    {
      "id": "SWW-VD-ZONDER-GE-001",
      "familyId": "SWW-VD-ZONDER-GE",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_zonder_ge",
      "questionType": "multiple_choice",
      "question": "Wat is het voltooid deelwoord van 'vertellen'?",
      "options": ["verteld", "geverteld", "vertelt", "vertelde"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "VD zonder ge-", "content": "Werkwoorden die beginnen met be-, ver-, ont-, her-, ge- of er- krijgen GEEN extra ge- in het voltooid deelwoord. Vertellen → verteld (niet geverteld).", "icon": "lightbulb"}}],
      "conceptId": "vd_ver_prefix",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Vertellen' begint met ver-. Werkwoorden met ver- krijgen geen ge- in het voltooid deelwoord. Stam = vertel. Kofschip: de 'l' staat niet in 't kofschip, dus +d. Antwoord: verteld.",
        "solutionSteps": ["Vertellen begint met ver- → geen ge-", "Stam = vertel", "L staat niet in 't kofschip → +d", "VD = verteld"],
        "distractorExplanations": {
          "0": "Goed! Vertellen → verteld (ver- = geen ge-).",
          "1": "Je dacht waarschijnlijk dat elk VD met ge- begint. Maar werkwoorden met ver-, be-, ont-, her-, ge- of er- krijgen geen extra ge-. Onthoud: ver-tel-d, niet ge-ver-teld.",
          "2": "Je hebt de tegenwoordige tijd geschreven (hij vertelt). Het voltooid deelwoord is verteld (met -d, niet -t aan het eind). Onthoud: VD = stam + d/t.",
          "3": "Je hebt de verleden tijd geschreven (hij vertelde). Het voltooid deelwoord is verteld (zonder -e). Onthoud: VD = stam + d/t, VT = stam + de/te."
        }
      }
    },
    {
      "id": "SWW-VD-ZONDER-GE-002",
      "familyId": "SWW-VD-ZONDER-GE",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_zonder_ge",
      "questionType": "multiple_choice",
      "question": "Welk werkwoord krijgt WEL ge- in het voltooid deelwoord?",
      "options": ["werken → gewerkt", "bezoeken → bezocht", "ontdekken → ontdekt", "vergeten → vergeten"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "rule",
          "data": { "title": "Voorvoegsels zonder ge-", "content": "be-, ver-, ont-, her-, ge-, er- → geen extra ge- in het VD", "icon": "lightbulb" }
        }
      ],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Wanneer wel ge-?", "content": "Alleen werkwoorden die NIET beginnen met be-, ver-, ont-, her-, ge- of er- krijgen ge- in het VD. 'Werken' begint gewoon met 'w', dus: gewerkt.", "icon": "lightbulb"}}],
      "conceptId": "vd_wel_ge",
      "variantIndex": 2,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "'Werken' begint niet met be-, ver-, ont-, her-, ge- of er-. Dus het VD krijgt wel ge-: gewerkt. De andere drie beginnen met be-, ont- of ver- en krijgen geen ge-. Zet om naar de ik-vorm: ik heb gewerkt ✓.",
        "solutionSteps": ["Werken begint met 'w' → wel ge-", "VD = gewerkt", "Bezoeken (be-), ontdekken (ont-), vergeten (ver-) → geen ge-", "Check: ik heb gewerkt ✓"],
        "distractorExplanations": {
          "0": "Goed! Werken → gewerkt (begint niet met be-/ver-/ont-/her-/ge-/er-).",
          "1": "Je dacht waarschijnlijk dat 'bezoeken' ge- krijgt. Maar bezoeken begint met be-, en werkwoorden met be- krijgen geen ge-. Onthoud: het VD is bezocht, niet gebezocht.",
          "2": "Je dacht waarschijnlijk dat 'ontdekken' ge- krijgt. Maar ontdekken begint met ont-, en werkwoorden met ont- krijgen geen ge-. Onthoud: het VD is ontdekt, niet geontdekt.",
          "3": "Je dacht waarschijnlijk dat 'vergeten' ge- krijgt. Maar vergeten begint met ver-, en werkwoorden met ver- krijgen geen ge-. Onthoud: het VD is vergeten, niet gevergeten."
        }
      }
    },
    {
      "id": "SWW-VD-ZONDER-GE-003",
      "familyId": "SWW-VD-ZONDER-GE",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_zonder_ge",
      "questionType": "multiple_choice",
      "question": "Wat is het voltooid deelwoord van 'beloven'?",
      "options": ["beloofd", "gebeloofd", "belooft", "beloven"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "VD met be-", "content": "Beloven begint met be- → geen ge-. De stam is 'beloof' (v wordt f aan het eind van de stam). Het VD is 'beloofd'. Let op: kijk naar de letter vóór -en in het hele werkwoord (v) voor de kofschip-keuze.", "icon": "lightbulb"}}],
      "conceptId": "vd_be_prefix",
      "variantIndex": 3,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "'Beloven' begint met be- → geen ge- in het VD. Voor de kofschip-keuze kijk je naar de letter vóór -en in het hele werkwoord: belov-en → de 'v' staat NIET in 't kofschip → +d. Het voltooid deelwoord is 'beloofd'. Let op: de stam is 'beloof' (v→f), maar voor kofschip kijk je naar het hele werkwoord.",
        "solutionSteps": ["Beloven begint met be- → geen ge-", "Kijk naar het hele werkwoord: belov-en → v", "V staat niet in kofschip → +d", "VD = beloofd"],
        "distractorExplanations": {
          "0": "Goed! Beloven → beloofd (be- = geen ge-, v niet in kofschip → +d).",
          "1": "Je dacht waarschijnlijk dat elk VD met ge- begint. Maar beloven begint met be-, dus geen ge-. Onthoud: be-, ver-, ont-, her-, ge-, er- = geen extra ge-.",
          "2": "Je hebt de tegenwoordige tijd geschreven (hij belooft). Het VD is beloofd (met -d). Onthoud: VD ≠ tegenwoordige tijd.",
          "3": "Je hebt de infinitief geschreven (beloven). Het VD is beloofd. Onthoud: het VD is een andere vorm dan de infinitief."
        }
      }
    },
    {
      "id": "SWW-VD-ZONDER-GE-004",
      "familyId": "SWW-VD-ZONDER-GE",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_zonder_ge",
      "questionType": "multiple_choice",
      "question": "Wat is het voltooid deelwoord van 'herstellen'?",
      "options": ["hersteld", "gehersteld", "herstelt", "herstelde"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "VD met her-", "content": "Herstellen begint met her-. Werkwoorden met her- krijgen geen ge-. Stam = herstel. L niet in kofschip → +d. VD = hersteld.", "icon": "lightbulb"}}],
      "conceptId": "vd_her_prefix",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "'Herstellen' begint met her- → geen ge-. Stam = herstel. De l staat niet in 't kofschip → +d. VD = hersteld.",
        "solutionSteps": ["Herstellen begint met her- → geen ge-", "Stam = herstel", "L niet in kofschip → +d", "VD = hersteld"],
        "distractorExplanations": {
          "0": "Goed! Herstellen → hersteld (her- = geen ge-).",
          "1": "Je dacht waarschijnlijk dat elk VD met ge- begint. Maar her- is een van de voorvoegsels waardoor je geen ge- toevoegt. Onthoud: be-, ver-, ont-, her-, ge-, er- = geen ge-.",
          "2": "Je hebt de tegenwoordige tijd geschreven (hij herstelt). Het VD is hersteld (met -d). Onthoud: VD = stam + d/t.",
          "3": "Je hebt de verleden tijd geschreven (hij herstelde). Het voltooid deelwoord is hersteld (zonder -e). Onthoud: VD = stam + d/t, VT = stam + de/te."
        }
      }
    },
    {
      "id": "SWW-VD-ZONDER-GE-005",
      "familyId": "SWW-VD-ZONDER-GE",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_zonder_ge",
      "questionType": "fill_in",
      "question": "Vul het voltooid deelwoord in: De brief is ... (bezorgen).",
      "options": [],
      "correctAnswer": "bezorgd",
      "data": {
        "acceptedAnswers": ["bezorgd"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "VD van bezorgen", "content": "Bezorgen begint met be- → geen ge-. Stam = bezorg. G niet in kofschip → +d. VD = bezorgd.", "icon": "lightbulb"}}],
      "conceptId": "vd_be_prefix_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Bezorgen begint met be- → geen ge-. Stam = bezorg. G niet in kofschip → +d. VD = bezorgd.",
        "solutionSteps": ["Be- → geen ge-", "Stam = bezorg", "G niet in kofschip → +d", "VD = bezorgd"]
      }
    },
    {
      "id": "SWW-VD-ZONDER-GE-006",
      "familyId": "SWW-VD-ZONDER-GE",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_zonder_ge",
      "questionType": "sentence_error_judge",
      "question": "In welke zin staat een fout bij het voltooid deelwoord? Klik op de fout.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "sentences": [
          { "text": "Hij heeft het verhaal geverteld.", "hasError": true, "correction": "verteld", "explanation": "'Vertellen' begint met ver- → geen ge-. Het VD is 'verteld', niet 'geverteld'." },
          { "text": "Zij heeft het pakket bezorgd.", "hasError": false },
          { "text": "Wij hebben het huis hersteld.", "hasError": false },
          { "text": "Ik heb het boek gelezen.", "hasError": false }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Geen ge- bij ver-, be-, ont-, her-", "content": "Werkwoorden met be-, ver-, ont-, her-, ge- of er- krijgen GEEN extra ge- in het VD. 'Vertellen' → verteld (niet geverteld). 'Bezorgen' → bezorgd. 'Herstellen' → hersteld.", "icon": "lightbulb" } }
      ],
      "conceptId": "vd_zonder_ge_error",
      "variantIndex": 6,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "'Geverteld' is fout. 'Vertellen' begint met ver- en krijgt geen ge-. Het juiste VD is 'verteld'. De andere zinnen zijn correct: bezorgd (be-), hersteld (her-), gelezen (lezen begint niet met een speciaal voorvoegsel → wel ge-).",
        "solutionSteps": [
          "Geverteld → FOUT: ver- = geen ge- → verteld",
          "Bezorgd → goed (be- = geen ge-)",
          "Hersteld → goed (her- = geen ge-)",
          "Gelezen → goed (lezen → wel ge-)"
        ]
      }
    },
    {
      "id": "SWW-VD-ZONDER-GE-007",
      "familyId": "SWW-VD-ZONDER-GE",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_zonder_ge",
      "questionType": "categorize",
      "question": "Sorteer deze werkwoorden: krijgt het VD wél of géén ge-?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Wél ge- in VD", "Géén ge- in VD"],
        "items": [
          { "text": "werken → gewerkt", "category": 0 },
          { "text": "vertellen → verteld", "category": 1 },
          { "text": "fietsen → gefietst", "category": 0 },
          { "text": "beloven → beloofd", "category": 1 },
          { "text": "koken → gekookt", "category": 0 },
          { "text": "ontdekken → ontdekt", "category": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Wel of geen ge-?", "content": "Werkwoorden met be-, ver-, ont-, her-, ge- of er- krijgen GEEN ge-. Alle andere werkwoorden krijgen WEL ge-. Werken → gewerkt ✓. Vertellen (ver-) → verteld ✓.", "icon": "lightbulb" } }
      ],
      "conceptId": "vd_ge_categorize",
      "variantIndex": 7,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De regel: werkwoorden die beginnen met be-, ver-, ont-, her-, ge- of er- krijgen GEEN extra ge- in het voltooid deelwoord. Waarom? Deze voorvoegsels zijn al onbeklemtoond — net als ge-. Twee onbeklemtoonde voorvoegsels achter elkaar klinkt niet in het Nederlands. Checkstrategie: zeg het VD hardop met én zonder ge-. 'Geverteld' klinkt onnatuurlijk → geen ge-. 'Werkt' mist iets → wél ge- → gewerkt.",
        "solutionSteps": [
          "Stap 1: Kijk naar het begin van het werkwoord — staat er be-, ver-, ont-, her-, ge- of er-?",
          "Stap 2a: Ja (vertellen=ver-, beloven=be-, ontdekken=ont-) → GEEN ge- in het VD",
          "Stap 2b: Nee (werken, fietsen, koken) → WÉL ge- in het VD",
          "Stap 3: Check door hardop te zeggen: 'geverteld' klinkt fout ✗ → verteld ✓",
          "Ezelsbruggetje: BEVO-HEG (be-, ver-, ont-, her-, er-, ge-) = geen extra ge-"
        ]
      }
    },
    {
      "id": "SWW-VD-ZONDER-GE-008",
      "familyId": "SWW-VD-ZONDER-GE",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_zonder_ge",
      "questionType": "drag_drop_fill",
      "question": "Sleep het juiste voltooid deelwoord naar de juiste zin.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "template": "Hij heeft het verhaal {0}.\nZij heeft een cadeau {1}.\nWij hebben het huis {2}.",
        "draggables": ["verteld", "gekocht", "hersteld", "geverteld", "gehersteld"],
        "correctPlacements": { "0": 0, "1": 1, "2": 2 }
      },
      "stimulusAids": [
        {
          "type": "rule",
          "data": { "title": "Voorvoegsels zonder ge-", "content": "be-, ver-, ont-, her-, ge-, er- → geen extra ge- in het VD. Andere werkwoorden → wél ge-.", "icon": "lightbulb" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "VD zonder ge-",
            "content": "Vertellen (ver-) → verteld (niet geverteld). Herstellen (her-) → hersteld (niet gehersteld). Kopen (geen voorvoegsel) → gekocht (wél ge-).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "vd_zonder_ge_drag_drop",
      "variantIndex": 8,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "'Vertellen' begint met ver- → geen ge- → verteld. 'Kopen' heeft geen speciaal voorvoegsel → wél ge- → gekocht. 'Herstellen' begint met her- → geen ge- → hersteld. De afleidersopties 'geverteld' en 'gehersteld' zijn fout omdat ver- en her- al een voorvoegsel zijn.",
        "solutionSteps": [
          "Vertellen (ver-) → geen ge- → verteld ✓",
          "Kopen (geen voorvoegsel) → wél ge- → gekocht ✓",
          "Herstellen (her-) → geen ge- → hersteld ✓",
          "Geverteld en gehersteld zijn fout: ver- en her- = geen extra ge-"
        ]
      }
    }
  ]
}